const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSetupWizard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-181"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.11,
    y: 398.62,
    width: 16.56,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.19,
    y: 394.99,
    width: 37.81,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 389.21,
    width: 69.08,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 12.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.06,
    y: 390.89,
    width: 36.83,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.33,
    y: 395.11,
    width: 59.53,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.27,243.56s-.69,16.14-27,16.14-27-16.14-27-16.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.27,231.24s-.69,16.15-27,16.15-27-16.15-27-16.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.02,
    y: 263.98,
    width: 20.75,
    height: 109.56,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.59,
    y: 373.54,
    width: 175.78,
    height: 8.86,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.77,
    y: 263.98,
    width: 170.17,
    height: 109.56,
    transform: "translate(317.71 637.52) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.27,
    y: 275.59,
    width: 139.17,
    height: 36.44,
    transform: "translate(317.71 587.61) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.27,
    y: 320.38,
    width: 139.17,
    height: 36.44,
    transform: "translate(317.71 677.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,280.61H142.53a3.15,3.15,0,0,1-3.14-3.14h0a3.15,3.15,0,0,1,3.14-3.15h32.65a3.15,3.15,0,0,1,3.14,3.15h0A3.15,3.15,0,0,1,175.18,280.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,325.41H142.53a3.15,3.15,0,0,1-3.14-3.15h0a3.15,3.15,0,0,1,3.14-3.14h32.65a3.15,3.15,0,0,1,3.14,3.14h0A3.15,3.15,0,0,1,175.18,325.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.77,
    y: 259.7,
    width: 175.43,
    height: 4.28,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.51,
    y: 259.7,
    width: 26.26,
    height: 4.28,
    transform: "translate(121.28 523.69) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.65,
    y: 93.39,
    width: 151.15,
    height: 136.42,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.25,
    y: 93.39,
    width: 156.34,
    height: 136.42,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.23,
    y: 102.38,
    width: 138.39,
    height: 118.46,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 413.62,
    y: 272.11,
    width: 11.48,
    height: 110.29,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.41,
    y: 272.11,
    width: 6.76,
    height: 110.29,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.76,
    y: 272.11,
    width: 11.48,
    height: 110.29,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.63,
    y: 272.11,
    width: 6.76,
    height: 110.29,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.3,
    y: 272.11,
    width: 100.97,
    height: 21.35,
    transform: "translate(759.57 565.57) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.97,
    y: 272.11,
    width: 11.48,
    height: 110.29,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.85,
    y: 272.11,
    width: 6.76,
    height: 110.29,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.92,
    y: 272.11,
    width: 58.46,
    height: 21.35,
    transform: "translate(590.31 565.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.84,
    y: 272.11,
    width: 11.48,
    height: 110.29,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.63,
    y: 272.11,
    width: 6.76,
    height: 110.29,
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-181"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-181",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--setup-wizard--inject-181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.48,292.52,73.17,78.46a7.24,7.24,0,0,1,7.3-7.75H324.6a8.31,8.31,0,0,1,8.19,7.75l12.3,214.06a7.22,7.22,0,0,1-7.29,7.74H93.66A8.29,8.29,0,0,1,85.48,292.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.8,300.74H93.66A8.8,8.8,0,0,1,85,292.55L72.7,78.48a7.69,7.69,0,0,1,7.77-8.24H324.6a8.79,8.79,0,0,1,8.66,8.19l12.31,214.06a7.71,7.71,0,0,1-7.77,8.25ZM86,292.49a7.83,7.83,0,0,0,7.71,7.3H337.8a6.77,6.77,0,0,0,6.82-7.24L332.32,78.48a7.83,7.83,0,0,0-7.72-7.29H80.47a6.75,6.75,0,0,0-6.82,7.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.47,292.52,76.16,78.46a7.24,7.24,0,0,1,7.3-7.75H327.59a8.31,8.31,0,0,1,8.19,7.75l12.3,214.06a7.22,7.22,0,0,1-7.29,7.74H96.65A8.29,8.29,0,0,1,88.47,292.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.79,300.74H96.65A8.8,8.8,0,0,1,88,292.55L75.69,78.48a7.69,7.69,0,0,1,7.77-8.24H327.59a8.79,8.79,0,0,1,8.66,8.19l12.31,214.06a7.71,7.71,0,0,1-7.77,8.25ZM83.46,71.19a6.75,6.75,0,0,0-6.82,7.24l12.3,214.06a7.83,7.83,0,0,0,7.71,7.3H340.79a6.77,6.77,0,0,0,6.82-7.24L335.31,78.48a7.85,7.85,0,0,0-7.72-7.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,101.63H102.31A5,5,0,0,1,97.45,97h0a4.3,4.3,0,0,1,4.33-4.59H170A4.94,4.94,0,0,1,174.86,97h0A4.3,4.3,0,0,1,170.53,101.63Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,117.54H103.22A4.94,4.94,0,0,1,98.37,113h0a4.3,4.3,0,0,1,4.32-4.6h54.77a4.94,4.94,0,0,1,4.86,4.6h0A4.3,4.3,0,0,1,158,117.54Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.79,138.08h-82a3.18,3.18,0,0,1-3.14-3h0a2.78,2.78,0,0,1,2.8-3h82a3.19,3.19,0,0,1,3.14,3h0A2.78,2.78,0,0,1,184.79,138.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.58,147.54H112.35a3.19,3.19,0,0,1-3.14-3h0a2.77,2.77,0,0,1,2.8-3h87.23a3.18,3.18,0,0,1,3.14,3h0A2.78,2.78,0,0,1,199.58,147.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.15,157H112.89a3.17,3.17,0,0,1-3.13-3h0a2.75,2.75,0,0,1,2.79-3h71.26a3.17,3.17,0,0,1,3.14,3h0A2.78,2.78,0,0,1,184.15,157Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.65,166.46H113.44a3.18,3.18,0,0,1-3.14-3h0a2.76,2.76,0,0,1,2.79-3h63.22a3.18,3.18,0,0,1,3.14,3h0A2.78,2.78,0,0,1,176.65,166.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,181.85H105.29a3.16,3.16,0,0,1-3.13-3h0a2.76,2.76,0,0,1,2.79-3h51.21a3.19,3.19,0,0,1,3.14,3h0A2.77,2.77,0,0,1,156.5,181.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,204.3H115.61a2.78,2.78,0,0,0-2.8,3h0a3.19,3.19,0,0,0,3.14,3h55.41a2.78,2.78,0,0,0,2.8-3h0A3.18,3.18,0,0,0,171,204.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,194.84H115.07a2.78,2.78,0,0,0-2.8,3h0a3.18,3.18,0,0,0,3.14,3H160.3a2.77,2.77,0,0,0,2.8-3h0A3.18,3.18,0,0,0,160,194.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.57,185.38h-50a2.77,2.77,0,0,0-2.79,3h0a3.17,3.17,0,0,0,3.13,3h50.05a2.77,2.77,0,0,0,2.8-3h0A3.19,3.19,0,0,0,164.57,185.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65,254H109.44a3.19,3.19,0,0,1-3.14-3h0a2.77,2.77,0,0,1,2.8-3h51.21a3.17,3.17,0,0,1,3.13,3h0A2.76,2.76,0,0,1,160.65,254Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.17,276.46H119.76a2.78,2.78,0,0,0-2.8,3h0a3.19,3.19,0,0,0,3.14,3h55.41a2.77,2.77,0,0,0,2.8-3h0A3.19,3.19,0,0,0,175.17,276.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.11,267h-44.9a2.77,2.77,0,0,0-2.79,3h0a3.18,3.18,0,0,0,3.14,3h44.89a2.78,2.78,0,0,0,2.8-3h0A3.19,3.19,0,0,0,164.11,267Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.72,257.54h-50a2.77,2.77,0,0,0-2.8,3h0a3.19,3.19,0,0,0,3.14,3h50.05a2.78,2.78,0,0,0,2.8-3h0A3.19,3.19,0,0,0,168.72,257.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.65,232.68H117.24a2.76,2.76,0,0,0-2.79,3h0a3.17,3.17,0,0,0,3.13,3H173a2.77,2.77,0,0,0,2.8-3h0A3.18,3.18,0,0,0,172.65,232.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.59,223.22H116.7a2.78,2.78,0,0,0-2.8,3h0a3.19,3.19,0,0,0,3.14,3h44.89a2.78,2.78,0,0,0,2.8-3h0A3.18,3.18,0,0,0,161.59,223.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.2,213.76h-50a2.77,2.77,0,0,0-2.79,3h0a3.18,3.18,0,0,0,3.14,3h50a2.78,2.78,0,0,0,2.8-3h0A3.19,3.19,0,0,0,166.2,213.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.06,136.1H235.33a26.54,26.54,0,0,1-26.16-24.73h0a23.11,23.11,0,0,1,23.32-24.74h0a26.53,26.53,0,0,1,26.15,24.74Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.08,131.82h0a21.94,21.94,0,0,1-21.62-20.45h0a19.09,19.09,0,0,1,19.27-20.45h0a21.93,21.93,0,0,1,21.63,20.45h0A19.1,19.1,0,0,1,235.08,131.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.34,103.09l1,16.56h-4.58l-.62-10.85a13.32,13.32,0,0,1-2.07,1.36,16.36,16.36,0,0,1-2.55,1l-.21-3.71a10.06,10.06,0,0,0,3.48-1.79,6.66,6.66,0,0,0,1.85-2.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.33,185.57h24.73a23.1,23.1,0,0,0,23.31-24.74h0a26.53,26.53,0,0,0-26.15-24.73h0a23.1,23.1,0,0,0-23.32,24.73Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.81,181.28h0a19.1,19.1,0,0,0,19.28-20.45h0a21.94,21.94,0,0,0-21.63-20.45h0a19.1,19.1,0,0,0-19.27,20.45h0A21.93,21.93,0,0,0,299.81,181.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,169.11H292.77a8,8,0,0,1,1.19-3.78,17.55,17.55,0,0,1,4.2-4.18,12.2,12.2,0,0,0,2.41-2.24,2.41,2.41,0,0,0,.48-1.46,1.79,1.79,0,0,0-.63-1.27,2,2,0,0,0-1.41-.53,1.78,1.78,0,0,0-1.38.55,3.09,3.09,0,0,0-.63,1.92l-4.55-.37a6.85,6.85,0,0,1,.8-3,4.12,4.12,0,0,1,1.91-1.64,8.68,8.68,0,0,1,3.55-.58,10.24,10.24,0,0,1,3.75.55,4.91,4.91,0,0,1,2.18,1.67,4.68,4.68,0,0,1,.91,2.53,5,5,0,0,1-.71,2.84,11,11,0,0,1-3,3c-.88.63-1.46,1.07-1.75,1.33a12.74,12.74,0,0,0-1,1h7.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.75,235H241a26.54,26.54,0,0,1-26.16-24.73h0a23.09,23.09,0,0,1,23.31-24.73h0a26.54,26.54,0,0,1,26.16,24.73Z",
    style: {
      fill: "#A0A0A0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.77,230.75h0a21.93,21.93,0,0,1-21.62-20.45h0a19.09,19.09,0,0,1,19.27-20.45h0A21.94,21.94,0,0,1,260,210.3h0A19.1,19.1,0,0,1,240.77,230.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.19,206.87l-4.32-.77a5,5,0,0,1,1.87-3.13,7,7,0,0,1,4.23-1.09,7.48,7.48,0,0,1,4.68,1.19,4,4,0,0,1,1.59,3,3.15,3.15,0,0,1-.47,1.91,4.5,4.5,0,0,1-1.65,1.5,5.18,5.18,0,0,1,1.47.54,3.77,3.77,0,0,1,1.34,1.32,4.09,4.09,0,0,1,.56,1.94,5.24,5.24,0,0,1-.59,2.73,4.54,4.54,0,0,1-2,2,7.88,7.88,0,0,1-3.63.71,9.78,9.78,0,0,1-3.54-.53,5.58,5.58,0,0,1-2.19-1.52,7.43,7.43,0,0,1-1.42-2.53l4.49-.6a3.86,3.86,0,0,0,.93,1.9A2.12,2.12,0,0,0,240,216a1.86,1.86,0,0,0,1.48-.66,2.49,2.49,0,0,0,.5-1.78,2.61,2.61,0,0,0-.68-1.76,2.23,2.23,0,0,0-1.62-.62,5.44,5.44,0,0,0-1.45.27l0-3.23a5.93,5.93,0,0,0,.6,0,2,2,0,0,0,1.45-.56,1.72,1.72,0,0,0,.51-1.35,1.74,1.74,0,0,0-.51-1.19,1.76,1.76,0,0,0-1.25-.44,1.71,1.71,0,0,0-1.27.48A2.82,2.82,0,0,0,237.19,206.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,284.5h24.73a23.11,23.11,0,0,0,23.32-24.74h0A26.54,26.54,0,0,0,302.9,235h0a23.09,23.09,0,0,0-23.31,24.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5,280.21h0a19.09,19.09,0,0,0,19.27-20.45h0a21.93,21.93,0,0,0-21.62-20.44h0a19.1,19.1,0,0,0-19.28,20.44h0A21.94,21.94,0,0,0,305.5,280.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.41,265h-8.24l-.21-3.72,7.67-9.8h3.95l.57,10h2.05l.2,3.51h-2l.18,3h-3.94Zm-.2-3.51-.3-5.12-4.06,5.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,235.91a.89.89,0,0,1-.88-.83l-5.68-98.93a.88.88,0,1,1,1.75-.1L272.83,235a.88.88,0,0,1-.82.93Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.8,285.37a.87.87,0,0,1-.87-.82l-2.85-49.47a.88.88,0,0,1,1.75-.1l2.85,49.47a.88.88,0,0,1-.83.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.12,136.1a1.73,1.73,0,0,1-1.74,1.85,2,2,0,0,1-2-1.85,1.73,1.73,0,0,1,1.75-1.85A2,2,0,0,1,268.12,136.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,138.83a2.87,2.87,0,0,1-2.83-2.68,2.6,2.6,0,0,1,2.62-2.78,2.88,2.88,0,0,1,2.83,2.68h0a2.61,2.61,0,0,1-.71,2A2.57,2.57,0,0,1,266.38,138.83Zm-.21-3.7a.87.87,0,0,0-.64.26.83.83,0,0,0-.23.66,1.11,1.11,0,0,0,1.08,1,.87.87,0,0,0,.64-.26.91.91,0,0,0,.23-.66A1.11,1.11,0,0,0,266.17,135.13Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,185.57a1.74,1.74,0,0,1-1.75,1.85,2,2,0,0,1-2-1.85,1.72,1.72,0,0,1,1.74-1.85A2,2,0,0,1,271,185.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.22,188.29a2.87,2.87,0,0,1-2.83-2.67,2.63,2.63,0,0,1,.71-2,2.6,2.6,0,0,1,1.91-.81,2.87,2.87,0,0,1,2.83,2.67h0a2.59,2.59,0,0,1-2.62,2.77Zm-.21-3.7a.88.88,0,0,0-.64.27.89.89,0,0,0-.23.66,1.11,1.11,0,0,0,1.08,1,.86.86,0,0,0,.87-.92A1.11,1.11,0,0,0,269,184.59Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.81,235a1.73,1.73,0,0,1-1.75,1.85,2,2,0,0,1-1.95-1.85,1.73,1.73,0,0,1,1.74-1.85A2,2,0,0,1,273.81,235Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.06,237.76a2.88,2.88,0,0,1-2.83-2.68,2.61,2.61,0,0,1,.71-2,2.56,2.56,0,0,1,1.91-.81,2.87,2.87,0,0,1,2.83,2.67h0a2.55,2.55,0,0,1-.7,2A2.61,2.61,0,0,1,272.06,237.76Zm-.21-3.7a.88.88,0,0,0-.64.26.92.92,0,0,0-.23.66,1.12,1.12,0,0,0,1.08,1,.88.88,0,0,0,.64-.27.83.83,0,0,0,.23-.66h0A1.11,1.11,0,0,0,271.85,234.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.65,284.5a1.73,1.73,0,0,1-1.74,1.85,2,2,0,0,1-2-1.85,1.73,1.73,0,0,1,1.75-1.85A2,2,0,0,1,276.65,284.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.91,287.22a2.87,2.87,0,0,1-2.83-2.67,2.55,2.55,0,0,1,.7-2,2.61,2.61,0,0,1,1.92-.82,2.88,2.88,0,0,1,2.83,2.68,2.6,2.6,0,0,1-2.62,2.77Zm-.21-3.7a.88.88,0,0,0-.64.27.83.83,0,0,0-.23.66,1.11,1.11,0,0,0,1.08,1,.88.88,0,0,0,.64-.26.92.92,0,0,0,.23-.66A1.11,1.11,0,0,0,274.7,283.52Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-181"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.55,154.52c.67,1,1.21,1.93,1.76,2.91s1.06,1.93,1.56,2.9c1,1.94,1.93,3.93,2.79,5.94a80.23,80.23,0,0,1,4.15,12.55l.35,1.64.17.82,0,.2.07.42a7.53,7.53,0,0,1,.09.8,10.92,10.92,0,0,1-1,4.79,26,26,0,0,1-3.94,6.11,57,57,0,0,1-9.6,9l-3.2-3.36a109.33,109.33,0,0,0,6.92-9.85,22.87,22.87,0,0,0,2.28-4.76,2.63,2.63,0,0,0,.15-1.32s0,0,0,0a0,0,0,0,0,0,0l-.06-.17-.2-.71-.42-1.4a93.1,93.1,0,0,0-4.32-11c-.83-1.82-1.74-3.59-2.64-5.37-.46-.88-.93-1.76-1.41-2.63s-1-1.76-1.43-2.49Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.08,197.45l-7.52.31,3,6.45s5.35-.3,7.36-3.54Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.7 200.66 411.56 206.44 414.59 204.22 411.56 197.76 409.7 200.66",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.07,407.46a11.32,11.32,0,0,0,2.42-.33.23.23,0,0,0,.17-.17.22.22,0,0,0-.09-.22c-.31-.21-3.07-2-4.14-1.52a.76.76,0,0,0-.44.61,1.21,1.21,0,0,0,.34,1.15A2.59,2.59,0,0,0,405.07,407.46Zm1.81-.64c-1.6.32-2.79.26-3.25-.16a.8.8,0,0,1-.21-.77.34.34,0,0,1,.18-.28C404.17,405.36,405.76,406.13,406.88,406.82Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.44,407.13a.2.2,0,0,0,.11,0,.23.23,0,0,0,.11-.19c0-.11,0-2.75-1-3.63a1.13,1.13,0,0,0-.91-.29.78.78,0,0,0-.74.61c-.22,1,1.42,3,2.28,3.5A.22.22,0,0,0,407.44,407.13Zm-1.5-3.71a.72.72,0,0,1,.47.19c.59.53.77,2,.81,2.89-.86-.7-1.88-2.18-1.74-2.81,0-.1.08-.23.36-.26Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,403.38a.24.24,0,0,0,.2-.09.21.21,0,0,0,0-.25c-.28-.36-2.74-3.45-4.07-3.54h-.09a.69.69,0,0,0-.59.35,1.13,1.13,0,0,0-.1,1.09c.53,1.22,3.12,2,4.62,2.43Zm-3.89-3.45c.73.05,2.27,1.6,3.32,2.86-2-.59-3.38-1.32-3.68-2a.75.75,0,0,1,.07-.72.27.27,0,0,1,.24-.14Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,403.38h0a.21.21,0,0,0,.17-.13c0-.09.91-2.34.27-3.68a1.63,1.63,0,0,0-.95-.85c-.58-.21-.88,0-1,.18-.61.83.53,3.5,1.33,4.41A.22.22,0,0,0,335.79,403.38Zm-.87-4.34a1.2,1.2,0,0,1,.95.69,4.68,4.68,0,0,1-.14,3c-.74-1.07-1.42-3.07-1.06-3.57A.26.26,0,0,1,334.92,399Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.69,123.34c-1,5.44-3.36,17.33.46,20.87,0,0-1.45,5.54-11.55,5.74-11.11.21-5.34-5.4-5.34-5.4,6.05-1.57,5.87-6.05,4.79-10.25Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.66,139.14a3,3,0,0,0-3.77-1.77,45.13,45.13,0,0,1-10.69,1.94,3.85,3.85,0,0,0-3.13,2l-4.29,7.56,24.46-3Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,114.31a.51.51,0,0,0,.18-.09.44.44,0,0,0,.07-.61,4.21,4.21,0,0,0-3.56-1.67.44.44,0,0,0-.39.48.42.42,0,0,0,.47.38h0a3.41,3.41,0,0,1,2.8,1.36A.44.44,0,0,0,379.32,114.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,119.67a20.06,20.06,0,0,1-2.24,5,3.17,3.17,0,0,0,2.66.24Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.6,118.34c.06.74-.29,1.37-.77,1.42s-.91-.52-1-1.26.28-1.37.76-1.41S377.54,117.6,377.6,118.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,117.11l-1.8-.34S376.05,118.06,376.83,117.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.53 409.15 335.66 406.1 341.92 386.37 350.78 389.43 344.53 409.15",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.68 407.2 408.52 407.2 407.69 386 416.85 386 417.68 407.2",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.23,405.86h10.28a.72.72,0,0,1,.72.62l1.06,8.14a1.5,1.5,0,0,1-1.49,1.63c-3.59-.06-5.31-.27-9.83-.27-2.79,0-6.85.28-10.7.28s-4-3.79-2.38-4.14c7.19-1.54,8.35-3.67,10.8-5.7A2.45,2.45,0,0,1,408.23,405.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.82,402.5l9.51,4.47a.71.71,0,0,1,.41.87l-2.45,7.64a1.5,1.5,0,0,1-2.07.78c-3.29-1.61-4.8-2.55-9-4.51-2.58-1.21-8-3.46-11.58-5.13s-2.09-5.09-.46-4.7c7.3,1.77,10.84,1.13,14,.4A2.56,2.56,0,0,1,336.82,402.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.92 386.38 338.56 396.94 347.56 399.6 350.79 389.43 341.92 386.38",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.85 386.01 407.69 386.01 408.12 396.93 417.28 396.93 416.85 386.01",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.05,145.37c3.81.76,7.95,14.35,7.95,14.35l-10.69,11.63s-9-12.66-7.21-17.42C412,149,415.55,144.48,420.05,145.37Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.05,145.37c3.81.76,7.95,14.35,7.95,14.35l-10.69,11.63s-9-12.66-7.21-17.42C412,149,415.55,144.48,420.05,145.37Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.07,154.19c-1.93-1.72-3.23-1.17-4.11.24-.85,4.08,4.38,12.48,6.49,15.66C417.39,166.23,418.45,158.1,414.07,154.19Z",
    style: {
      fill: "#A0A0A0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,148.53c-.68,4-.83,16.19,5.42,53.16l37.2-.73c-.71-15.11-.78-24.43,6.28-55.59a109.44,109.44,0,0,0-15.81-1.77,118.18,118.18,0,0,0-16.89.34c-5.41.59-11.35,1.77-14,2.33A2.79,2.79,0,0,0,371.15,148.53Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.15,148.53c-.68,4-.83,16.19,5.42,53.16l37.2-.73c-.71-15.11-.78-24.43,6.28-55.59a109.44,109.44,0,0,0-15.81-1.77,118.18,118.18,0,0,0-16.89.34c-5.41.59-11.35,1.77-14,2.33A2.79,2.79,0,0,0,371.15,148.53Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,113.48c.17,9.09.44,12.94-3.74,18-6.29,7.63-17.46,6-20.34-2.82-2.6-7.94-2.45-21.48,6.09-25.92A12.22,12.22,0,0,1,402.09,113.48Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.83,111.11c7.23-1.44,16.72-3.89,18.61-9.17S375.93,92.54,376.83,111.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,113.5c-1-.51-2.89-3.68-1.72-9.2s9.89-10.47,16.72-6.58C390.17,100.5,382.39,113.5,382.39,113.5Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.78,107.78c-1.22,5.11,0,8.76,2,10.64,0,0-5,32.94,20,29.36s10.43-41,4.58-46.49S386.83,93.09,381.78,107.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.93,115.73a9.16,9.16,0,0,0-1.36,5.49c.18,2.44,2.09,2.44,3.49,1s2.63-4.47,1.92-6.33S383,114,381.93,115.73Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.4,201.49s5.67,62.66,11.39,97.93c4.62,28.48,8.53,95.12,8.53,95.12H418.8s4.07-65,1.65-93.26c-6.14-71.39,4.91-78.06-6.68-100.32Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.09,222.44c-3.25,4.78-7.59,10.29-9,16.11,1.12,10.57,2.43,22.26,3.85,33.5C397.38,262.6,403.26,243.71,399.09,222.44Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.57,201.69s-14.91,67.42-20,94.89c-5.32,28.58-17.65,93.34-17.65,93.34l12.45,6.4s23-78,26.08-92.38c8.12-30.06,34.12-102.9,34.12-102.9Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.33 392.59 351.46 398.62 354.4 393.35 338.21 386.88 336.33 392.59",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.61 394.79 420.5 394.79 421.42 389.21 404.6 388.64 404.61 394.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.32,198.77l1.7,3.29c.13.25-.18.52-.61.53l-39,.77c-.34,0-.62-.16-.64-.37l-.35-3.31c0-.23.26-.43.63-.44l37.67-.74A.65.65,0,0,1,414.32,198.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.28,203.07l1,0c.2,0,.36-.11.34-.23l-.5-4.31c0-.13-.19-.23-.39-.23l-1,0c-.2,0-.35.11-.34.24l.5,4.31C408.91,203,409.08,203.08,409.28,203.07Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,203.55l1,0c.2,0,.35-.11.33-.23l-.49-4.31c0-.13-.19-.23-.4-.23l-1,0c-.21,0-.36.11-.34.24l.49,4.31C384.45,203.46,384.63,203.56,384.83,203.55Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.36,157.16a115.83,115.83,0,0,1-6.94,12.51c-1.29,2-2.61,4-4.08,6-.7,1-1.49,1.93-2.24,2.89s-1.6,1.89-2.48,2.8a25.49,25.49,0,0,1-3,2.77,31.32,31.32,0,0,1-3.26,2.22,47.73,47.73,0,0,1-6.71,3.28,68.58,68.58,0,0,1-13.88,3.85l-1.2-4.47a120.2,120.2,0,0,0,12-5.81,48.08,48.08,0,0,0,5.38-3.45,24.47,24.47,0,0,0,2.28-1.91,16.11,16.11,0,0,0,1.92-2.13,92.67,92.67,0,0,0,7.3-10.83c1.15-1.91,2.21-3.88,3.29-5.84s2.13-4,3.11-5.89Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.87,146.13c-8.79,1.9-11.75,14.76-11.75,14.76l11.22,9.67s11.42-11.74,11-18.79C384.07,146.53,378.66,145.1,373.87,146.13Z",
    style: {
      fill: "#A0A0A0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.87,146.13c-8.79,1.9-11.75,14.76-11.75,14.76l11.22,9.67s11.42-11.74,11-18.79C384.07,146.53,378.66,145.1,373.87,146.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.17,192.74l-8.89,4.51-3.3-7.6s7.87-1.82,11.25-.13Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.89 198.81 322.44 193.66 325.98 189.65 329.28 197.25 325.89 198.81",
    style: {
      fill: "#ff8b7b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetupWizard);
export default __webpack_public_path__ + "static/media/SetupWizard.44d4e7fc414560c9d602e01b1448a67f.svg";
export { ForwardRef as ReactComponent };